// Written by Codex on 2026-10-15
// User prompt: demo readiness
import React from 'react';

export default function ProfileRecoveryPanel({ error, onRetry, onSignOut, loading = false }) {
  return <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
    <section aria-labelledby="profile-recovery-title" className="max-w-md space-y-4 rounded-2xl bg-white p-8 shadow-sm">
      <h1 id="profile-recovery-title" className="text-lg font-semibold text-slate-900">Unable to load your profile</h1>
      <p role="alert" className="text-sm text-slate-600">{error}</p>
      <div className="flex flex-wrap gap-3">
        <button type="button" disabled={loading} onClick={onRetry} className="rounded-lg bg-teal-700 px-4 py-2 text-sm text-white disabled:opacity-50">{loading ? 'Loading profile…' : 'Retry profile'}</button>
        <button type="button" onClick={onSignOut} className="rounded-lg border border-slate-300 px-4 py-2 text-sm text-slate-700">Sign out</button>
      </div>
    </section>
  </div>;
}
